// extracted by mini-css-extract-plugin
export default {"container":"NewAdminUserModal_container__uMoE6","inputs__container":"NewAdminUserModal_inputs__container__rArD6","phone__input":"NewAdminUserModal_phone__input__aAn0M"};